import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/excecaoMeta/actions';

import Form from './form';

function PitStopExcecaoMeta() {
  const redux = useSelector((state) => state.excecaoMeta);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'numeroexcecaometa',
        label: t('s.cadastro.pitstop.numeroexcecaometa'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaoexcecaometa',
        label: t('s.cadastro.pitstop.descricaoexcecaometa'),
        filter: { type: 'text' },
      },
      {
        id: 'statusexcecaometa',
        label: t('s.cadastro.pitstop.statusexcecaometa'),
        formatted: (value) =>
          status.find((item) => item.label === value)?.value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idexcecaometa"
      detach="numeroexcecaometa"
    />
  );
}

export default PitStopExcecaoMeta;